export interface ApiResponse<T> {
    status: boolean;
    success?: boolean;
    data: T;
}
